import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';


export default {
  saveCityInformation(hotelId, name, configs) {
    const cityObj = {
      name,
      configs
    };

    return Firebase.firestore()
      .collection('hotels')
      .doc(hotelId)
      .update(cityObj);
  },

  hotelTypes(){
    return Firebase.firestore().collection('hotelTypes')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  destinations(){
    return Firebase.firestore().collection('destinations')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/Information/service.js